module.exports = __webpack_public_path__ + "media/images/icons/scheduling-c48c6f3ad7c9f26bd2dbfd253776374c.svg";